import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const alertThemeToken: any = {
  //====================== COLOR =============================/
  colorIcon: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorIconHover: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  withDescriptionColorIcon: variableColors["ColorFigmaNeutralWhiteWhite100"],

  colorInfo: variableColors["ColorFigmaComplementaryBlue50"],
  colorInfoBg: variableColors["ColorFigmaComplementaryBlue10"],
  colorInfoBorder: variableColors["ColorFigmaComplementaryBlue10"],

  colorWarning: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningBg: variableColors["ColorFigmaFunctionalWarning10"],
  colorWarningBorder: variableColors["ColorFigmaFunctionalWarning10"],

  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSuccessBg: variableColors["ColorFigmaFunctionalSuccess10"],
  colorSuccessBorder: variableColors["ColorFigmaFunctionalSuccess10"],

  colorError: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorBg: variableColors["ColorFigmaFunctionalAlert10"],
  colorErrorBorder: variableColors["ColorFigmaFunctionalAlert10"],

  //====================== SIZE =============================/
  borderRadiusLG: 0,
  defaultPadding: "10px 16px",
  fontSizeIcon: variableTypography["BodyH400FontSize"],
  fontSizeCloseIcon: 16,
  withDescriptionIconSize: 32,
  withDescriptionPadding: 0,

  withDescriptionFontSize: variableTypography["BodyH300FontSize"],
  withDescriptionFontWeight: variableTypography["BodyH300FontWeight"],
  withDescriptionLineHeight: variableTypography["BodyH300LineHeight"],

  fontSize: variableTypography["BodyMediumFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  fontSizeLG: variableTypography["BodyMediumFontSize"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  marginSM: 16,
  marginXS: 8,
};
